import gql from 'graphql-tag';

const penggunaFragment = gql `
  fragment penggunaFragment on Pengguna {
    id
    uuid
    nama
    nip
    alamat
    telepon
    avatar
    tgl_lahir
    role
    status
    ttd
    sertifikat
    golongan {
      id
      nama
      keterangan
    }
    jabatan {
      id
      nama
      bidang {
        id
        nama
        uuid
      }
    }
    login {
      username
      uuid
      id
    }
    hak_akses {
      id
      uuid
      tipe_akses
      name
      url
      icon
      show
      order
      parentakses_id
      is_group
      pivot{
        id 
        pengguna_id
        hak_akses_id
      }
      submenu{
        id
        uuid
        tipe_akses
        name
        url
        icon
        show
        parentakses_id
        is_group
        submenu{
          id
          uuid
          tipe_akses
          name
          url
          icon
          show
          parentakses_id
        }
      }
    }
  }
`;

const ALL = gql `
  query all($perPage: Int!, $page: Int, $where: PenggunaWhereWhereConditions) {
    pengguna(first: $perPage, page: $page, where: $where) {
      data {
        ...penggunaFragment
      }
    }
  }
  ${penggunaFragment}
`;

const FIND = gql `
  query find($where: PenggunaFindWhereWhereConditions) {
    pengguna: penggunaFind(where: $where) {
      ...penggunaFragment
    }
  }
  ${penggunaFragment}
`;

const ALL_BY_BIDANG = gql `
  query all($jabatanId: ID!, $penggunaId: ID){
    penggunaGetByBidang(jabatanId: $jabatanId, penggunaId: $penggunaId) {
      nama
      nama_jabatan
      avatar
      telepon
      alamat
      bidang_uuid
    }
  }
`;

const ATASAN_PENGGUNA = gql `
  query penggunaGetAtasan($penggunaId: ID!){
    penggunaGetAtasan(penggunaId: $penggunaId) {
      nama
      nama_jabatan
      avatar
    }
  }
`;

const UPDATE = gql `
    mutation($id: ID!, $input:PenggunaUpdateInput!){
        penggunaUpdate(id: $id,input:$input){
            nama,
            nip,
            jabatan_id,
            golongan_id,
            alamat,
            telepon,
            tgl_lahir,
            status,
            sertifikat,
            ttd
        }
    }
`

const CREATE = gql `
  mutation($input:PenggunaCreateInput!){
    penggunaCreate(input:$input){
      id,
      uuid,
      nip,
      nama,
      alamat,
      telepon,
      golongan_id,
      role,
      tgl_lahir,
      login {
        username,
        password
      }
    }
  }
`

const GET_ALL_FILTER = gql `
  query Pengguna($perPage: Int!, $page: Int, $where: PenggunaFilterWhereWhereConditions) {
    pengguna: penggunaFilter(first: $perPage, page: $page, where: $where) {
      data {
        ...penggunaFragment
      }
      paginatorInfo {
        count
        total
        hasMorePages
        currentPage
        lastPage
        perPage
      }
    }
  }
  ${penggunaFragment}
`;

export {
  ALL,
  FIND,
  ALL_BY_BIDANG,
  UPDATE,
  CREATE,
  GET_ALL_FILTER,
  ATASAN_PENGGUNA
};
